import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronDown } from "lucide-react";
import { faq } from "../data/mockData";

/** Questions fréquentes : titre et invitation à gauche, réponses à droite. */
export const Faq = () => (
  <section id="faq" className="section section-alt">
    <div className="shell grid gap-10 lg:grid-cols-12 lg:gap-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-28">
          <h2 className="h2">Questions fréquentes</h2>
          <p className="lede mt-5">
            Ce que l'on nous demande le plus souvent avant de commencer un
            mandat, une formation ou un projet sur LizPack.
          </p>
          <div className="mt-8 rounded-[20px] border border-border bg-white p-6">
            <p className="font-display text-vt-h3 font-bold text-brand">
              Une autre question ?
            </p>
            <p className="mt-2 leading-relaxed text-t2">
              Écrivez-nous : nous répondons sous 24 h ouvrables.
            </p>
            <Link to="/#contact" className="btn-accent btn-sm mt-5">
              Nous écrire
              <ArrowRight className="h-[1.125rem] w-[1.125rem]" strokeWidth={2.4} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>

      <div className="space-y-4 lg:col-span-8">
        {faq.map(({ q, r }) => (
          <details
            key={q}
            className="group rounded-[20px] border border-border bg-white"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-6 p-6 font-display text-vt-h3 font-bold text-brand lg:px-8 [&::-webkit-details-marker]:hidden">
              {q}
              <ChevronDown
                className="h-6 w-6 flex-none text-brand group-open:rotate-180"
                strokeWidth={2.2}
                aria-hidden="true"
              />
            </summary>
            <p className="px-6 pb-6 leading-relaxed text-t2 lg:px-8">{r}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
